import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const SidebarContainer = superstyled({
  name: 'ThreadSidebar',
  slot: 'Container',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: theme.palette.grey[950],
    width: '100%'
  })
});

export const SidebarHeader = superstyled({
  name: 'ThreadSidebar',
  slot: 'Header',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.border.main}`,
    flexShrink: 0
  })
});

export const SidebarContent = superstyled({
  name: 'ThreadSidebar',
  slot: 'Content',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: theme.spacing(1),

    // Custom scrollbar styling
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.action.disabled,
      borderRadius: '3px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.action.hover
    }
  })
});

export const LoadingContainer = superstyled({
  name: 'ThreadSidebar',
  slot: 'LoadingContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    height: '200px'
  })
});

export const LoadingText = superstyled({
  name: 'ThreadSidebar',
  slot: 'LoadingText',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body2.fontSize
  })
});

export const EmptyStateContainer = superstyled({
  name: 'ThreadSidebar',
  slot: 'EmptyStateContainer',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(4),
    textAlign: 'center'
  })
});

export const EmptyStateText = superstyled({
  name: 'ThreadSidebar',
  slot: 'EmptyStateText',
  tag: Text,
  styles: () => ({
    // color: theme.palette.text.secondary,
    // fontSize: theme.typography.body2.fontSize,
    // lineHeight: 1.5
  })
});

export const ThreadGroups = superstyled({
  name: 'ThreadSidebar',
  slot: 'ThreadGroups',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  })
});

export const ThreadList = superstyled({
  name: 'ThreadSidebar',
  slot: 'ThreadList',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5)
  })
});

// Placeholder styles for thread items (will be replaced by ThreadListItem component)
// export const ThreadItemPlaceholder = superstyled({
//   name: 'ThreadSidebar',
//   slot: 'ThreadItemPlaceholder',
//   tag: Box,
//   propsNeeded: ['isActive'],
//   styles: ({ theme, isActive }) => ({
//     padding: theme.spacing(2),
//     margin: `0 ${theme.spacing(1)}`,
//     borderRadius: theme.shape.borderRadius,
//     cursor: 'pointer',
//     transition: 'all 0.2s ease-in-out',
//     backgroundColor: isActive ? theme.palette.action.selected : 'transparent',
//     border: isActive ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',

//     '&:hover': {
//       backgroundColor: isActive ? theme.palette.action.selected : theme.palette.action.hover
//     },

//     '&:focus': {
//       outline: `2px solid ${theme.palette.primary.main}`,
//       outlineOffset: '2px'
//     }
//   })
// });

export const ThreadTitle = superstyled({
  name: 'ThreadSidebar',
  slot: 'ThreadTitle',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  })
});

export const ThreadDate = superstyled({
  name: 'ThreadSidebar',
  slot: 'ThreadDate',
  tag: Text,
  styles: ({ theme }) => ({
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary
  })
});
